import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=372dab3a&scoped=true&"
import script from "./ItemSelector.vue?vue&type=script&lang=js&"
export * from "./ItemSelector.vue?vue&type=script&lang=js&"
import style0 from "./ItemSelector.vue?vue&type=style&index=0&id=372dab3a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372dab3a",
  null
  
)

export default component.exports